import { LayoutDashboard, Users, KeyRound, Activity, Terminal, LogOut, ShieldCheck } from "lucide-react";

const NAV = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "grupos", label: "Grupos", icon: Users },
  { id: "licencias", label: "Licencias", icon: KeyRound },
  { id: "membresias", label: "Membresías", icon: ShieldCheck },
  { id: "actividad", label: "Actividad", icon: Activity },
  { id: "comandos", label: "Comandos", icon: Terminal },
];

export default function Sidebar({ active, onChange, onLogout, botState }) {
  const stateMap = {
    ready: { t: "Conectado", c: "text-emerald-400", d: "bg-emerald-400" },
    qr: { t: "Esperando QR", c: "text-gold", d: "bg-gold" },
    starting: { t: "Iniciando…", c: "text-gold", d: "bg-gold" },
    disconnected: { t: "Desconectado", c: "text-crimson", d: "bg-crimson" },
    offline: { t: "Offline", c: "text-muted-foreground", d: "bg-zinc-500" },
  };
  const s = stateMap[botState] || stateMap.offline;
  return (
    <aside className="hidden lg:flex flex-col w-64 shrink-0 bg-obsidian border-r border-white/10 min-h-screen sticky top-0">
      <div className="flex items-center gap-3 px-6 h-20 border-b border-white/10">
        <img src="/logo.png?v=20260724-groups" alt="logo" className="w-14 h-14 rounded object-contain" />
        <div className="leading-tight">
          <div className="font-heading font-bold text-lg">AC WARDEN</div>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Control Room</div>
        </div>
      </div>
      <nav className="flex-1 p-4 space-y-1">
        {NAV.map((n) => {
          const Icon = n.icon;
          const on = active === n.id;
          return (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => onChange(n.id)}
              className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-md text-sm font-medium transition-all ${
                on ? "bg-gold text-black" : "text-muted-foreground hover:bg-white/5 hover:text-white"
              }`}
            >
              <Icon size={18} /> {n.label}
            </button>
          );
        })}
      </nav>
      <div className="p-4 border-t border-white/10 space-y-3">
        <div className="flex items-center gap-2 px-2">
          <span className={`w-2 h-2 rounded-full ${s.d} animate-pulse`} />
          <span className={`text-xs font-medium ${s.c}`}>{s.t}</span>
        </div>
        <button
          data-testid="logout-button"
          onClick={onLogout}
          className="w-full flex items-center gap-2 px-4 py-2 rounded-md text-sm text-muted-foreground hover:bg-white/5 hover:text-white transition-all"
        >
          <LogOut size={16} /> Salir
        </button>
      </div>
    </aside>
  );
}
